module.exports = __webpack_public_path__ + "img/logo.e00ff41c.png";